import { useEffect } from 'react';
import { M, useAnimate } from '@/utils/Motion';
import { promptLogin } from '@/services/app/mcd';
import { Login as LoginLayout } from '@CS/routes';
import BaseButton from '@/components/BaseButton/BaseButton';
import { LogoABZ, MCDLogo } from '@/assets/images';

type LoginProps = {
  onLogin: () => void;
  onError?: (error: Error) => void;
};

const LoginMotion = M.create(LoginLayout);

export const Login = ({ onLogin, onError }: LoginProps) => {
  const [scope, animate] = useAnimate();

  useEffect(() => {
    animate(
      'section > :nth-child(1)',
      { translate: '0 0', opacity: 1 },
      { duration: 0.4, delay: 0.0 }
    );

    animate(
      'section > :nth-child(2)',
      { translate: '0 0', opacity: 1 },
      { duration: 0.4, delay: 0.2 }
    );

    animate(
      'section > :nth-child(3)',
      { translate: '0 0', opacity: 1 },
      { duration: 0.4, delay: 0.4 }
    );

    animate(
      'section > :nth-child(4)',
      { translate: '0 0', opacity: 1 },
      { duration: 0.4, delay: 0.6 }
    );
  }, []);

  const onClick = () =>
    promptLogin()
      .then(() => onLogin())
      .catch(error => onError?.(error));

  return (
    <LoginMotion
      ref={scope}
      onLogin={onClick}
      topLogoSrc={MCDLogo}
      topLogoAlt="McDonald's Logo"
      mainLogoSrc={LogoABZ}
      mainLogoAlt="Logo ABZ"
      cta={<BaseButton onClick={onClick} text="Inloggen" />}
    />
  );
};
